import moment from 'moment';

const defaultTaskState = [
  'unassigned',
  'assigned',
  'waiting_for_acknowledgement',
  'acknowledged',
  'started',
  'arrived',
  'successful',
  'failed',
  'declined',
  'cancelled',
  'collected',
];

const initialState = {
  filter: {
    myJobs: {
      date: moment().format('YYYY-MM-DD'),
    },
    task: {},
    job: {},
    archives: {
      date: moment().format('YYYY-MM-DD'),
    },
  },
};

function filter(state = initialState, action) {
  switch (action.type) {
    case 'RESET_FILTER_STATUS':
      return {
        ...state,
        filter: {
          ...state.filter,
          task: {
            ...state.filter.task,
            state: defaultTaskState,
          },
          job: {
            ...state.filter.job,
            state: null,
          },
        },
      };
    case 'RECEIVE_MYJOBS_FILTER_UPDATE':
      return {
        ...state,
        filter: {
          ...state.filter,
          myJobs: action.myJobsFilter,
        },
      };
    case 'RECEIVE_MYJOBS_TASK_FILTER_UPDATE': {
      const filterTask = { ...action.myJobsTaskFilter };
      delete filterTask.date;
      return {
        ...state,
        filter: {
          ...state.filter,
          myJobs: {
            ...state.filter.myJobs,
            date: action.myJobsTaskFilter.date,
          },
          task: filterTask,
        },
      };
    }
    case 'RECEIVE_ARCHIVES_FITLER_UPDATE':
      return {
        ...state,
        filter: {
          ...state.filter,
          archives: action.archivesFilter,
        },
      };
    default:
      return state;
  }
}

export default filter;
